import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import { useParams } from 'react-router-dom';

const tabla = {
    iD:0
      , evaluacionID:0
      , versionID:0
      , periodoEvaluacion:0
      , fechaDesde:""
    , fechaHasta: ""
    , empleadoID: ""
    , supervisorID: ""
    , nombres: ""
    , posicion: ""
    , dependencia: ""
    , supervisor: ""
    , fechaingreso: ""
    , posicionSup: ""
    }


const ReporteEvaluacion = () => {
    let {ordenID } = useParams();
    let {placa } = useParams();
   
    
   
    const [DatosP, SetDatosP] = useState(tabla);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Listado1, SetListado1] = useState([]);
    const [Listado2, SetListado2] = useState([]);


    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        //setTabla({
        //    ...tabla,
        //    [e.target.name]: value
        //})
    }


    const obtenerDatos = async () => {
        let response = await fetch(Api + "Evaluacion/ReporteEvaluacion/2/00000813");

        if (response.ok) {
            let data = await response.json()
            if (pendiente == true) {
              SetDatosP(data)
            }
         
            setPendiente(false)
        }
    }

    useEffect(() => {
        ListaResumen();
        ListaOrdenLinea();
    })

    const ListaOrdenLinea = async () => {
        let response = await fetch(Api + "Transporte/ListaOrdenLinea/" + ordenID);
        if (response.ok) {
            let data1 = await response.json()
            SetListado1(data1)

        }
    }
    const ListaResumen = async () => {
        let response = await fetch(Api + "Transporte/ListaResumido/" + ordenID);
        if (response.ok) {
            let data1 = await response.json()
            SetListado2(data1)

        }
    }

    return (

        <div >
           

            <div class="printArea">
                <div class="page1">
                    <div style={{ paddingBottom:"40px" }} ></div>
                    {/*Informacion printer*/}
                    <br />
                    <h4> SOLICITUD DE BILL OF LADING</h4>
                    <div style={{ paddingBottom: "40px" }} ></div>
                    <div>
                        <table class="table table-border D_Table">
                        <tr>
                            <td><b>EXPORTADOR (NOMBRE COMPLETO)</b></td>
                            <td>Nelson Sanchez De La Cruz ( Danilo Cuesto Polanco )</td>
                        </tr>    <tr>
                                <td><b>DIRECCION FISICA, ZIP CODE</b></td>
                            <td>Calle Morel Campos #423 en Bo.Obrero, 00915 San Juan PR</td>
                        </tr>    <tr>
                                <td><b>SEGURO SOCIAL (DE LLEVAR AES)</b></td>
                            <td> </td>
                        </tr>    <tr>
                                <td><b>NUMERO DE PASAPORTE</b></td>
                            <td>RD6600341</td>
                        </tr>    <tr>
                            <td><b>NUMERO DE CEDULA</b></td>
                            <td>001-0710731-0</td>
                        </tr>    <tr>
                            <td><b>NUMERO DE CEL/TEL</b></td>
                            <td>787-217-9490</td>
                        </tr>    <tr>
                            <td><b>TABLILLA/MATRICULA</b></td>
                                <td>{ placa}</td>
                        </tr>    <tr>
                            <td><b>CONSIGNATORIO (NOMBRE COMPLETO)</b></td>
                            <td>Guillermina Sanchez</td>
                        </tr>    <tr>
                            <td><b>DIRECCION FISICA, ZIP CODE</b></td>
                            <td>Autopista Las Americas K 19/5, Calle Amarilla (atrás de la
                                Ferreteria La Mina, Sto. Dgo, RD.)</td>
                        </tr><tr>
                            <td><b>NUMERO DE PASAPORTE</b></td>
                            <td>SP1257891</td>
                        </tr><tr>
                            <td><b>NUMERO DE CEDULA</b></td>
                            <td>100-0004755-4</td>
                        </tr><tr>
                            <td><b>NUMERO DE RNC</b></td>
                            <td>131938795</td>
                        </tr>
                    </table>
                    </div>
                </div>



                    <div >
                 {/*   info cliente item*/}
                    <div>
                        <table class="table table-border D_Table">
                            <tr>
                                <th>LCL
                                    BOL
                                    INVOICE
                                    NO.</th>
                           
                                <th>SHIPPER\
                                    EXPORTER
                                    NAME</th>
                                <th>SHIPPER
                                    EXPORTER
                                    PHONE</th>
                                <th>SHIPPER
                                    EXPORTER
                                    ADDRES</th>
                            <th>ID</th>
                                <th>DESCRIPTION
                                    OF GOODS
                                    DECLARED</th>
                                <th>GOODS
                                    TOTAL
                                    VALUE
                                    DECLARED</th>
                            </tr>
                            { Listado1.map( x => <tr>
                                <td>{x.no_Invoice}</td>
                                <td>{x.nombreCliente}</td>
                                <td>{x.telefono}</td>
                                <td>{x.direccion}</td>
                                <td>{x.id}</td>
                                <td>{x.descripcion}</td>
                                <td>{"$"+x.monto}</td>

                            </tr>)}
                        </table>
                    </div>
                </div>



                <br />
                <br />
                <br />
                <br />
                <br />
                    {/*Resument*/}
                    <div class="page ">
               <div     style={{ paddingBottom: "40px" }} >
                        <table class="table table-border D_Table BG_Title">
                            <tr class="">
                                <th>Articulos</th>
                                <th>Cantidad</th>
                            </tr>
                        {Listado2.map(x => <tr>
                            <td>{x.descripcion}</td>
                            <td>{x.cantidad}</td>
                        </tr>)
                        }
                        </table>
                    </div>
</div>

       

        </div>
        </div>
    )

}
export default ReporteEvaluacion;